import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Styles
import styles from './IconButton.module.scss';

const cx = classNames.bind(styles);
const noOp = () => {};

const IconButton = ({
  children,
  className = '',
  dataCy = '',
  dataTest = '',
  onClick = noOp,
  size = 'small',
  circled = false,
  ...rest
}) => {
  const closeClassName = cx('icon-button', className, {
    'icon-button--circled': circled
  });

  return (
    <button
      type="button"
      onClick={onClick}
      className={closeClassName}
      data-cy={dataCy}
      data-test={dataTest}
      size={size}
      {...rest}
    >
      {children}
    </button>
  );
};

IconButton.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  dataCy: PropTypes.string,
  dataTest: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['normal', 'small', 'extra_small']),
  circled: PropTypes.bool
};

export default IconButton;
